/* MARVI OCEAN - Four4Luck interactions.

   The counter only ever shows a number that came back from the Worker.
   No Worker, no network, bad response: the block stays hidden. The pledge
   still works. It simply does not claim a crowd it cannot count. */
(function(){
'use strict';
function boot(){
  var moment    = document.getElementById('f4lMoment');
  var answer    = document.getElementById('f4lAnswer');
  var answerTxt = document.getElementById('f4lAnswerText');
  var pledgeBtns= document.getElementById('f4lPledgeBtns');
  var pledgeDone= document.getElementById('f4lPledgeDone');
  var countBox  = document.getElementById('f4lCount');
  var countNum  = document.getElementById('f4lCountNum');
  var countLbl  = document.getElementById('f4lCountLabel');
  var share     = document.getElementById('f4lShare');
  var copyBtn   = document.getElementById('f4lCopy');

  var F4L = window.F4LCount;
  if(!F4L) return;

  var REPLIES = {
    pickup: 'That instinct to bend down is the whole movement, already in you.',
    walk:   'Thank you for the honest answer. That is exactly where this starts.'
  };

  /* Show the count only if the Worker gave us a real number. */
  function paintCount(data){
    if(!data || typeof data.pledged !== 'number') return;
    var n = F4L.format(data.pledged);
    if(n === null) return;
    countNum.textContent = n;
    countLbl.textContent = data.pledged === 1 ? 'person has pledged' : 'people have pledged';
    countBox.hidden = false;
  }

  /* If the pledge is live, fetch the running total on load. */
  if(F4L.enabled()){
    F4L.read().then(paintCount);
  }

  /* ---- the honest question ---- */
  var choices = document.querySelectorAll('.f4l-choice');
  for(var i=0;i<choices.length;i++){
    choices[i].addEventListener('click', function(){
      var c = this.getAttribute('data-choice');
      answerTxt.textContent = REPLIES[c] || '';
      moment.hidden = true;
      answer.hidden = false;
      answer.scrollIntoView({behavior:'smooth', block:'center'});
      F4L.send('answered');
    });
  }

  /* ---- the pledge ---- */
  var mine = F4L.myPledge();
  if(mine){
    pledgeBtns.hidden = true;
    pledgeDone.hidden = false;
    pledgeDone.textContent = mine === 'in'
      ? 'You are in. Four pieces, next time you are out.'
      : 'No pressure. The ocean will still be there.';
    if(mine === 'in') share.hidden = false;
  }

  var btns = pledgeBtns.querySelectorAll('[data-pledge]');
  for(var j=0;j<btns.length;j++){
    btns[j].addEventListener('click', function(){
      var action = this.getAttribute('data-pledge');
      for(var k=0;k<btns.length;k++) btns[k].disabled = true;

      F4L.send(action).then(function(data){
        pledgeBtns.hidden = true;
        pledgeDone.hidden = false;
        pledgeDone.textContent = action === 'in'
          ? 'You are in. Four pieces, next time you are out.'
          : 'No pressure. The ocean will still be there.';
        if(action === 'in') share.hidden = false;
        paintCount(data);
      });
    });
  }

  /* ---- share ---- */
  if(copyBtn){
    copyBtn.addEventListener('click', function(){
      var text = document.getElementById('f4lShareLine').textContent.trim();
      if(!navigator.clipboard) return;
      navigator.clipboard.writeText(text).then(function(){
        copyBtn.textContent = 'Copied';
        copyBtn.classList.add('is-copied');
        setTimeout(function(){
          copyBtn.textContent = 'Copy and pass it on';
          copyBtn.classList.remove('is-copied');
        }, 2000);
      });
    });
  }
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot);
else boot();
})();
